<template>
	<div>
		<!-- desktop-computer -->
		<svg v-if="name === 'desktop-computer'" v-bind="$attrs" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
			<path
				d="M13 17h-2v2h2v-2zm2 0v2h2a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2h2v-2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5zM4 5v10h16V5H4z"
			/>
		</svg>

		<!-- trash -->
		<svg viewBox="0 0 20 20" fill="currentColor" v-if="name === 'trash'" v-bind="$attrs">
			<path
				fill-rule="evenodd"
				d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
				clip-rule="evenodd"
			></path>
		</svg>

		<!-- x -->
		<svg v-if="name === 'x'" viewBox="0 0 20 20" fill="currentColor" v-bind="$attrs">
			<path
				fill-rule="evenodd"
				d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
				clip-rule="evenodd"
			></path>
		</svg>

		<!-- plus -->
		<svg v-if="name === 'plus'" v-bind="$attrs" viewBox="0 0 20 20" fill="currentColor">
			<path
				fill-rule="evenodd"
				d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
				clip-rule="evenodd"
			></path>
		</svg>

		<svg
			v-if="name === 'information-circle'"
			v-bind="$attrs"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
			></path>
		</svg>

		<!-- draggable-handle -->
		<svg v-if="name === 'draggable-handle'" v-bind="$attrs" viewBox="0 0 11 16" xmlns="http://www.w3.org/2000/svg">
			<circle cx="2.22798" cy="1.45455" r="1.45455" />
			<circle cx="8.77486" cy="1.45455" r="1.45455" />
			<circle cx="2.22798" cy="14.5454" r="1.45455" />
			<circle cx="8.77486" cy="14.5454" r="1.45455" />
			<circle cx="2.22798" cy="8.00044" r="1.45455" />
			<circle cx="8.77486" cy="8.00044" r="1.45455" />
		</svg>

		<!-- microphone -->
		<svg
			v-if="name === 'microphone'"
			v-bind="$attrs"
			xmlns="http://www.w3.org/2000/svg"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
			viewBox="0 0 24 24"
		>
			<path
				d="M13 18.94V21h3a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2h3v-2.06A8 8 0 0 1 4 11a1 1 0 0 1 2 0 6 6 0 1 0 12 0 1 1 0 0 1 2 0 8 8 0 0 1-7 7.94zM12 1a4 4 0 0 1 4 4v6a4 4 0 1 1-8 0V5a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v6a2 2 0 1 0 4 0V5a2 2 0 0 0-2-2z"
			/>
		</svg>

		<!-- pencil -->
		<svg v-if="name === 'pencil'" viewBox="0 0 20 20" fill="currentColor" v-bind="$attrs">
			<path
				d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
			></path>
		</svg>

		<!-- chevron-right -->
		<svg
			v-if="name === 'chevron-right'"
			v-bind="$attrs"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
		</svg>

		<!-- chevron-left -->
		<svg
			v-if="name === 'chevron-left'"
			v-bind="$attrs"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
		</svg>

		<!-- chevron-up -->
		<svg
			v-if="name === 'chevron-up'"
			v-bind="$attrs"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
		</svg>

		<!-- chevron-down -->
		<svg
			v-if="name === 'chevron-down'"
			v-bind="$attrs"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
		</svg>

		<!-- menu-alt4 -->
		<svg
			v-if="name === 'menu-alt4'"
			v-bind="$attrs"
			fill="none"
			stroke="currentColor"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16"></path>
		</svg>
	</div>
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			required: true
		}
	}
}
</script>
